module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cf_stills_pet_1.5_cepita_fresh_pomelo.2a991841.png";